import React, { FC, useState } from 'react';
import { Menu, Dropdown, Typography, Space } from 'antd';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { LogOutIcon, KeyOutlineIcon, LanguageIcon } from '~/img';

import './styles.less';
import { auth } from '~/api/axios';
import ChangePassword from '~/components/ChangePassword';
import { useIdentityUsePermissionsUseVerifyToken } from '~/hooks/identity';
import { Avatar } from '~/components';
import { selectProfiles } from '~/slices/ui';
import featuresWithDefaults from '~/featuresWithDefaults';
import { queryClient } from '~/index';
import i18n from '~/i18n';

const Overlay: FC = () => {
  const history = useHistory();
  const [t, i18n] = useTranslation();

  const onLogout = () => {
    auth.deleteToken();
    history.push('/login');
  };

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleMenuItemClick = ({ key }: any) => {
    if (featuresWithDefaults.i18n.userLanguages.includes(key)) {
      queryClient.invalidateQueries();
      void i18n.changeLanguage(key);
    }
  };

  return (
    <>
      <ChangePassword open={open} onClose={handleClose} />
      <Menu
        mode="inline"
        selectedKeys={[i18n.language]}
        selectable={false}
        onClick={handleMenuItemClick}
        className="menu-shadow"
      >
        <Menu.SubMenu icon={<LanguageIcon />} title={t('language')}>
          {Languages()}
        </Menu.SubMenu>
        <Menu.Item icon={<KeyOutlineIcon />} onClick={handleOpen}>
          {t('changePassword')}
        </Menu.Item>
        <Menu.Item icon={<LogOutIcon />} onClick={onLogout}>
          {t('logout')}
        </Menu.Item>
      </Menu>
    </>
  );
};

export const Languages = () => {
  const t = i18n.getFixedT(null, 'languages');
  return (
    <>
      {featuresWithDefaults.i18n.userLanguages.map((lng) => {
        return <Menu.Item key={lng}>{t(lng)}</Menu.Item>;
      })}
    </>
  );
};

const Profile: FC = () => {
  const { data } = useIdentityUsePermissionsUseVerifyToken();
  const profile = useSelector(selectProfiles);
  const individual = profile.data?.find((item) => item.type === 'INDIVIDUAL');
  return (
    <div className="Profile">
      <Dropdown trigger={['click']} overlay={<Overlay />} placement="bottomRight" arrow>
        <Space className="Profile-DropdownArea" size={14}>
          <Typography.Text className="Header-Title">{data?.name}</Typography.Text>
          <Avatar size={30} file={individual?.icon} />
        </Space>
      </Dropdown>
    </div>
  );
};

export default Profile;
